import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgUserService
    ,FvmsApiAuthService
    ,FvmsApiDtgTeamService
    ,FvmsExcelService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import { DtgManageUserFormComponent } from "../form/dtg.manage.user.form.component";

@Component({
    selector: "dtg-manage-user-list"
    ,templateUrl: './dtg.manage.user.list.component.html'
    ,providers: []
})
export class DtgManageUserListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    companyInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    dayDiff:number=0;
    listUser:any[];
    listTeam:any[];
    listUserGroup:any[];
    searchValue:string;
    userGroupId:number = null;
    limitUserGroupId:number = null;
    dtgTeamId:string = "";
    @Input() listType:DtgListType = DtgListType.list;
    @Output() userInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    
    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsExcelService:FvmsExcelService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.limitUserGroupId = this.currentUserInfo.userGroupId;
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 10;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
        this.getListUserGroup();
        this.reloadListItemTeam();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,userId : null
            ,limitUserGroupId : this.currentUserInfo.userGroupId
            ,searchValue : this.searchValue
            ,userGroupId : this.userGroupId
        };
        this.fvmsApiDtgUserService.getListUser(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listUser = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    // 셀렉트박스 등급
    getListUserGroup(){
        let searchInfo = {
            limitUserGroupId : this.currentUserInfo.userGroupId
        };
        this.fvmsApiDtgUserService.getListUserGroup(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listUserGroup = apiResponse.resultValue;
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo.companyId || 0
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectUser(userInfo:any){
        this.userInfo.emit(userInfo);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    changeUserGroup(e){
        this.reloadListItem();
    }

    changeTeamInfo(event){
        this.reloadListItem();
    }

    clickSearch(){
        this.reloadListItem();
    }

    clickOpenModalUserInfo(dtgActionType:DtgActionType,userInfo:any){
        let modalRef = this.modalService.open(
            DtgManageUserFormComponent
            ,{
                centered:true
                // ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = userInfo?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.userId = userInfo?.userId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    exportExcel(){
        this.fvmsCommonService.setIsLoading(true);
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,userId : null
            ,limitUserGroupId : this.currentUserInfo.userGroupId
            ,searchValue : this.searchValue
            ,userGroupId : this.userGroupId
        };
        let paging = new PagingInfo();
        paging.pageSize=999999;
        this.fvmsApiDtgUserService.getListUser(searchInfo,paging)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    let listItems = apiResponse.resultValue;
                    let listJson = this.convertExcelJson(listItems);
                    this.fvmsExcelService.excelDownload(listJson,"listUser");
                    this.fvmsCommonService.setIsLoading(false);
                }
            });
    }

    convertExcelJson(dataList:any[]){
        return dataList.map((v,i) => {
            return {
                 "그룹이름":v.dtgTeamNm || "미설정"
                ,"권한":v.userGroupNm
                ,"ID":v.userId
                ,"이름":v.userNm || "미설정"
                ,"이름(단말)":v.dtgDriverNm || "미설정"
                ,"운전자코드":v.dtgDriverLcsNo || "미설정"
            };
        });
    }
}